import { Button, Menu, MenuItem } from '@mui/material'
import type React from 'react'
import { useState } from 'react'
import { useIsFilteredState } from './shared.hooks'

interface OwnProps {
  isSchedule: boolean
}

const StatusFilterDropDown: React.FC<OwnProps> = ({ isSchedule }) => {
  const [isFiltered, setIsFiltered] = useIsFilteredState(
    isSchedule ? 'schedule' : 'deviance',
  )
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isOpen = anchorEl !== null

  const DisplayText = isSchedule
    ? '未実施のみ'
    : '逸脱項目のあるスケジュールのみ'

  const renderSelectButton = (isFiltered: boolean) => (
    <MenuItem
      onClick={() => {
        setIsFiltered(isFiltered)
        setAnchorEl(null)
      }}
    >
      {isFiltered ? DisplayText : 'すべて'}
    </MenuItem>
  )

  return (
    <>
      <Button
        color="secondary"
        variant="contained"
        onClick={({ currentTarget }) => {
          setAnchorEl(currentTarget)
        }}
      >
        {isSchedule ? '入力状況: ' : '逸脱状況: '}
        {isFiltered ? DisplayText : 'すべて'}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => {
          setAnchorEl(null)
        }}
      >
        {renderSelectButton(false)}
        {renderSelectButton(true)}
      </Menu>
    </>
  )
}

export default StatusFilterDropDown
